<template>
    <transition name="animate">
        <div
            ref="toolTip"
            class="g tool-tip"
            :class="className"
            :style="'top:'+ top +'px; left:'+ left +'px; pointer-events:'+ pointerEvents"
            @mouseenter="clearTimer"
            @mouseleave="setTimer"
        >
            <component
                :is="type"
                :content="content"
                :sn="sn"
                @sendEvent="receiveEvent"
            ></component>
        </div>
    </transition>
</template>

<script>
    import toolTip from '@/tooltips/toolTip'

    import { mapMutations } from 'vuex'

    export default {
        components: {
            toolTip,
            showCalendarInfo: resolve => require(['@/tooltips/showCalendarInfo'], resolve),
            showCalendarMore: resolve => require(['@/tooltips/showCalendarMore'], resolve),
        },
        props: {
            type: {
                require: true
            },
            sn: {
                require: true
            },
            event: { //可以傳事件，也可以傳 target
                require: true
                // require: false
            },
            content: { //依照模板定義
                require: true
            },
            pointerEvents: {
                type: String,
                require: false,
                default: 'auto'
            },
            fixedNode: { //是否是版面固定元件
                type: Boolean,
                require: false,
                default: false
            }
        },
        data: function(){
            return {
                className: [],
                top: 0,
                left: 0,
                timer: null,
                delay: 150
            }
        },
        methods: {
            ...mapMutations([
                'clearToolTip'
            ]),
            setPos: function(){ //計算tooltip 定位
                let $toolTip = this.$refs.toolTip;

                let $evt = this.event,
                    $target = $evt.target,
                    $rect = $target.getBoundingClientRect(),
                    _nodeTop = $rect.top,
                    _nodeLeft = $rect.left,
                    _nodeHeight = $target.offsetHeight,
                    _nodeWidth = $target.offsetWidth;

                let $body = document.body,
                    _clientWidth = $body.clientWidth,
                    _clientHeight = $body.clientHeight,
                    _toolTipHeight = $toolTip.offsetHeight,
                    _toolTipWidth = $toolTip.offsetWidth;

                let _int = 5; //緩衝

                if( _nodeTop > _toolTipHeight ){ //顯示在上面
                    this.top = _nodeTop - _toolTipHeight + _int;
                    this.className.push('bottom');
                }else if( _nodeTop + _toolTipHeight - _int < _clientHeight ){
                    this.top = _nodeTop + _nodeHeight + _int;
                    this.className.push('top');
                }else {
                    this.clearToolTip();
                    
                    return false;
                }

                if( _nodeLeft + _toolTipWidth > _clientWidth ){
                    this.left = _nodeLeft + _nodeWidth - _toolTipWidth;
                    this.className.push('right');
                }else {
                    this.left = _nodeLeft;
                    this.className.push('left');
                }
            },
            clearTimer: function(){
                window.clearTimeout(this.timer);
            },
            setTimer: function(){
                this.clearTimer();

                this.timer = window.setTimeout(() => {
                    this.clearToolTip();
                }, this.delay);
            }
        },
        mounted: function(){
            this.setPos();

            let $evt = this.event;

            if( $evt ) {
                let $target = $evt.target,
                    _eventType = $evt.type;

                if( $target === undefined ) {
                    $target = this.event;
                    _eventType = '';
                }

                let $childrens = $target.querySelectorAll('*');

                if( _eventType.match(/^on/) === null ) { //如果沒有 on 前輟
                    _eventType = 'on'+ _eventType;
                }

                $childrens.forEach(node => { //阻止子物件冒泡
                    node[_eventType] = (event) => {
                        event.stopPropagation();
                    }
                });

                if( $target.tagName !== 'path' ) {
                    $target.onmouseenter = () => {
                        this.clearTimer();
                    }

                    $target.onmouseleave = () => {

                        if( this.pointerEvents === 'none' ) {
                            this.clearToolTip();
                        }else if( this.pointerEvents === 'auto' ) {
                            this.setTimer();
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .g.tool-tip {
        $w: 6px;
        $int: 2;

        position: fixed;
        z-index: 1101;
        padding-top: $w * $int;

        &.top {
            margin-top: $int * 1px;

            &::before {
                top: 0;
                border-bottom-color: $white;
                border-left-color: $white;
            }
        }

        &.bottom {
            margin-top: -1px * $int;
            padding-top: 0;
            padding-bottom: $w * $int;

            &::before {
                bottom: 0;
                border-top-color: $white;
                border-left-color: $white;
            }
        }

        &.left {

            &::before {
                left: $interval-s;
            }
        }

        &.right {

            &::before {
                right: $interval-s;
            }
        }

        &::before {
            content: $content;
            position: absolute;
            height: 0;
            width: 0;
            border-width: $w;
            border-style: solid;
            border-color: transparent;
        }

        &::v-deep {
            
            .g.tool-tip-inner {
                padding: $interval-m;
                background-color: $white;
                z-index: 3;
                border-radius: $border-radius;
                box-shadow: 0 0 $interval-xxl $gray;
            }

            .g.tool-tip-content {

                + .md.btn-list {
                    padding-top: $interval-s;
                }
            }

            .g.tool-tip-content-inner {
                font-size: $font-size-s;

                > div {

                }
            }
        }
    }
</style>
